import React, { FunctionComponent } from "react";

import FormFieldError from "../fieldError";
import { IField } from "@/types/hubspot";

type Props = {
  field: IField;
  callback: Function;
};
const FormSelect: FunctionComponent<Props> = ({ field, callback }) => {
  const options = field.options?.map((option) => {
    return (
      <option key={`${option.label}-${option.value}`} value={option.value}>
        {option.label}
      </option>
    );
  });

  const handleChange = (value: string) => {
    callback({
      ...field,
      value: value,
    });
  };

  return (
    <div className={`mb-4 ${field.hidden ? "hidden" : ""}`}>
      <label
        htmlFor={field.name}
        className={`mb-2 block text-sm font-medium${field.error ? "text-red-700" : ""}`}
      >
        {field.label}
        {!field.required ? " (optional)" : ""}
      </label>
      <select
        id={field.name}
        name={field.name}
        className={`block w-full rounded-lg border p-2.5 ${field.error ? "border-red-500 bg-red-50 text-red-900 placeholder-red-700 focus:border-red-500 focus:ring-red-500" : "border-gray-300 bg-gray-50 text-gray-900 focus:border-blue-500 focus:ring-blue-500"}`}
        onChange={(event) => handleChange(event.target.value)}
      >
        <option value="">{`${field.label}${!field.required ? " (optional)" : ""}`}</option>
        {options}
      </select>
      <FormFieldError field={field} error={field.error} />
    </div>
  );
};

export default FormSelect;
